import "./_tableau.scss";

import cx from "classnames";

import {TableauPrix} from "./interface";

function Tableau({
  lignes,
  thead,
  firstCellUnit = "",
}: {
  lignes?: TableauPrix[];
  thead?: JSX.Element;
  firstCellUnit?: string;
}): JSX.Element | undefined {
  if (lignes) {
    const Tableau = lignes.map((ligne, index) => {
      const Celules = ligne.celules.map((celule, index) => {
        return (
          <td key={index.toString() + celule}>
            {celule
              ? `${parseFloat(celule).toFixed(2)} €`
              : "Prix non renseigné"}
          </td>
        );
      });
      const isEuro = firstCellUnit === "prix";
      return (
        <tr
          key={index.toString() + ligne.firstCell}
          className={cx(index % 2 === 0 ? "background-white" : "")}>
          {ligne.firstCell && (
            <td>
              {`${new Intl.NumberFormat("fr-FR").format(
                typeof ligne.firstCell === "number"
                  ? ligne.firstCell
                  : parseFloat(ligne.firstCell),
              )} ${isEuro ? "€" : ""}`}
            </td>
          )}
          {Celules}
        </tr>
      );
    });
    return (
      <table className="tableau-prix">
        {thead || (
          <thead>
            <tr></tr>
          </thead>
        )}
        <tbody>{Tableau}</tbody>
      </table>
    );
  }
}

export default Tableau;
